import { Component, OnInit } from '@angular/core';
import { Alert, ALERT_TYPE } from '../../../../../../../components/alert/alert.model';
import { AlertComponent } from '../../../../../../../components/alert/alert.component';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { TranslationService } from '@spartacus/core'; // Importe o TranslationService
import { Subscription } from 'rxjs';

@Component({
  selector: 'cart-free-shipping-message',
  standalone: true,
  imports: [AlertComponent],
  templateUrl: './cart-free-shipping-message.component.html',
  styleUrl: './cart-free-shipping-message.component.scss',
})
export class CartFreeShippingMessageComponent implements OnInit {
  //consider using input instead of cartActiveService when backend is done
  alertInfo: Alert = {
    isActive: true,
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.INFO,
  };
  subscription = new Subscription();

  constructor(
    protected activeCartService: ActiveCartService,
    protected translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.handleFreeDeliveryMessage();
  }

  handleFreeDeliveryMessage() {
    this.subscription.add(
      this.activeCartService.getActive().subscribe(cart => {
        if (cart?.freeDelivery?.isFree) {
          this.translationService.translate('cart.cartItems.freeDeliverySuccess').subscribe(translation => {
            this.alertInfo.content = translation;
          });
        } else {
          this.translationService
            .translate('cart.cartItems.freeDeliveryWarning', { amount: cart?.freeDelivery?.remainingAmount.formattedValue })
            .subscribe(translation => {
              this.alertInfo.content = translation;
            });
        }
      }),
    );
  }
}
